import React, { useRef, useState, useEffect } from 'react'
import { filter, shuffle } from 'lodash'
import {
  findRequiredArrayForSmartTile,
  twoDimensionShuffle
} from '../utils/SmartTileUtils'
import {
  NOT_SKIPPED,
  TILE_MATCHED,
  SMALL_DESKTOP,
  LARGE_DESKTOP,
  MEDIUM_DESKTOP,
  TUTOR_BOT,
  FEEDBACK_BOT
} from '../constants'
import 'katex/dist/katex.min.css'
import {
  getTimeSpent,
  getTimeSpentOverall,
  getSubmitDate
} from '../utils/TimerUtils'
import HeaderCarousel from './HeaderCarousel'
import { SmartTile } from './SmartTile'
import { BotAssistSettings } from '../UIUtilsFiles/BotAssistSettings'
import { getNonRepeatingFeedback } from '../utils/FeedbackUtils'

function SmartTileMainScreen(props) {
  const { user, currentLessonUnitDistId } = props // from redux state
  const {
    activityDataFromParent,
    isBgAudioPlayed,
    minutes,
    seconds,
    isActive,
    onToastTrigger,
    isPreview,
    isSequence,
    isClassroom,
    isMinimize,
    Completed
  } = props
  const { showOrHideToaster } = props //from dispatch
  const {
    secondsPractice,
    minutesPractice,
    activitySaveClick,
    activitySaveType,
    activityResetType,
    isKnovoHelpOpen
  } = props //values from parent activity screen
  const {
    getStudentWorkedDataFromChild,
    getStudentCurrentScore,
    getTutorTalking,
    getActivityResetStatus,
    knovoHelpClose,
    getValidationFeedback,
    getActivityLoaded
  } = props //values from parent activity screen

  //Activity data
  const [currentActivity, setCurrentActivity] = useState({})
  const { ActivityJson, ContentID, ActivityType, WorkJson, Feedback, Status } =
    currentActivity
  const IsReadonly = false
  const SAVE_MODE = { SAVE: 'SAVE', SUBMIT: 'SUBMIT' }
  const isPractice = isPreview
    ? true
    : ActivityType === 'practice'
    ? true
    : false

  //Smart tile based variables
  const [smartTileData, setSmartTileData] = useState({
    TotalScore: '',
    TopTile: '',
    BottomTile: '',
    TileRatio: '',
    TotalTiles: '',
    DocumentTitle: '',
    SmartTileBoxes: [],
    DesktopSmartTileBoxes: [],
    BackgroundImage: '',
    Opacity: 'rgba(255,255,255,0)',
    FontName: 'Anodina',
    FontColor: '#000000',
    Bold: false,
    Italic: false,
    FillColor: '#ffffff',
    FontSize: 'MEDIUM',
    TextToSpeech: [],
    Seconds: []
  })
  const [smartTileArray, setSmartTileArray] = useState([])
  const [shuffledArray, setShuffledArray] = useState([])
  const [maxColumnCount, setMaxColumnCount] = useState(0)
  const [topTileFlex, setTopTileFlex] = useState(0)
  const [bottomTileFlex, setBottomTileFlex] = useState(0)
  const [totalScore, setTotalScore] = useState(0)

  //Tutor variables
  const [botAudioData, setBotAudioData] = useState('')
  const [ttsData, setTtsData] = useState([])
  const [tutorialStart, setTutorialStart] = useState(false)
  const [isSubtitle, setIsSubtitle] = useState(true)
  const [isTutorPlayed, setIsTutorPlayed] = useState(false)
  const [ttsPlayType, setTtsPlayType] = useState('')
  const [feedbackType, setFeedbackType] = useState('')
  const [isAudioForcedStopped, setIsAudioForcedStopped] = useState(false)
  const [isAudioPlaying, setIsAudioPlaying] = useState(true)

  //Attempts and score variables
  const [attempt, setAttempt] = useState(0)
  const [attemptsPractice, setAttemptsPractice] = useState(0)
  const [currentScore, setCurrentScore] = useState(0)
  const [currentScoreApi, setCurrentScoreApi] = useState(0)
  const [currentScoreReset, setCurrentScoreReset] = useState(0)
  const [cumulativeAverageScoreOld, setCumulativeAverageScoreOld] = useState(0)

  //Header item variables
  const [selectedValue, setSelectedValue] = useState(undefined)
  const [sourceItem, setSourceItem] = useState(undefined)
  const [selectedIndex, setSelectedIndex] = useState(-1)
  const [answeredTile, setAnsweredTile] = useState(undefined)
  //Audio file variables
  const [sound, setSound] = useState(undefined)
  const [audio, setAudio] = useState(undefined)
  const [playing, setPlaying] = useState(false)
  //Reset variables
  const [popupType, setPopupType] = useState('')
  const [confirmPopupVisible, setConfirmPopupVisible] = useState(false)
  const [resetValue, setResetValue] = useState(0)
  const [totalResetPractice, setTotalResetPractice] = useState(0)
  const [totalResetOld, setTotalResetOld] = useState(0)
  //Teacher feedback variables
  const [feedbackVisible, setFeedbackVisible] = useState(false)
  //Hint variables
  const [hintClick, setHintClick] = useState(false)
  const [hintMessage, setHintMessage] = useState('')
  // Check Answer variables
  const [currentDisplayMode, setcurrentDisplayMode] = useState('normal')
  const isVerifyMode = currentDisplayMode === 'verify'
  // Answer Explanation variables
  const [explanationClick, setExplanationClick] = useState(false)
  //Empty tile animation variable
  const [isEmptyTileVisible, setIsEmptyTileVisible] = useState(false)

  useEffect(() => {
    if (isBgAudioPlayed) {
      setCurrentActivity(activityDataFromParent)
    } else {
      setSmartTileArray([])
      setShuffledArray([])
      setSourceItem(undefined)
      setSelectedIndex(-1)
      setSelectedValue(undefined)
      setSourceItem(undefined)
      setcurrentDisplayMode('normal')
      setTtsPlayType('')
      setIsTutorPlayed(false)
      setTutorialStart(false)
      setIsAudioPlaying(false)
      setBotAudioData('')
    }
  }, [isBgAudioPlayed])

  useEffect(() => {
    if (ActivityJson) {
      smartTileJsonData(ActivityJson)
    }
  }, [currentActivity])

  //feed all the data to smarttile data
  function smartTileJsonData(activityJson) {
    const exercise = JSON.parse(activityJson)
    setSmartTileData({
      TotalScore: exercise.TotalScore,
      TopTile: exercise.TopTile,
      BottomTile: exercise.BottomTile,
      TileRatio: exercise.TileRatio,
      TotalTiles: exercise.TotalTiles,
      DocumentTitle: exercise.DocumentTitle,
      SmartTileBoxes: exercise.SmartTileBoxes,
      DesktopSmartTileBoxes: exercise.DesktopSmartTileBoxes,
      BackgroundImage: exercise.BackgroundImage,
      Opacity: exercise.Opacity,
      FontName: exercise.FontName,
      FontColor: exercise.FontColor,
      Bold: exercise.Bold,
      Italic: exercise.Italic,
      FillColor: exercise.FillColor,
      FontSize: exercise.FontSize,
      TextToSpeech: exercise.TextToSpeech,
      Seconds: exercise.Seconds
    })
  }

  //check tutor message is available and play
  useEffect(() => {
    if (smartTileData.DesktopSmartTileBoxes.length > 0) {
      setTopTileFlex(parseInt(smartTileData.TileRatio.split(':')[0]))
      setBottomTileFlex(parseInt(smartTileData.TileRatio.split(':')[1]))
      setTotalScore(smartTileData.TotalScore)
      if (isActive && Completed === 0) {
        checkTutorInstructions()
      } else {
        setTutorialStart(false)
        setIsTutorPlayed(true)
      }
    }
  }, [smartTileData])

  //check tutor message is available and play
  function checkTutorInstructions() {
    let botTtsData = getTutorAudio()
    if (botTtsData.tutorTtsAudio !== '') {
      setTtsPlayType(TUTOR_BOT)
      setBotAudioData(botTtsData.tutorTtsAudio)
      setTutorialStart(true)
    } else {
      setTutorialStart(false)
      setIsTutorPlayed(true)
    }
    if (botTtsData.tutorTtsText !== '') {
      setTtsData(botTtsData.tutorTtsText)
    }
  }

  //Get initial instructions data
  function getTutorAudio() {
    const exercise = JSON.parse(ActivityJson)
    let tutorBotData = {
      tutorTtsAudio: '',
      tutorTtsText: []
    }
    if (exercise.SpeechAudioData) {
      let activityInitialInstruction = exercise.SpeechAudioData
      if (activityInitialInstruction.speechAudioLink) {
        tutorBotData.tutorTtsAudio = activityInitialInstruction.speechAudioLink
      }
      if (activityInitialInstruction.speechAudioLink) {
        tutorBotData.tutorTtsText = activityInitialInstruction.speechData
      }
    }
    return tutorBotData
  }

  useEffect(() => {
    if (isTutorPlayed) {
      setBotAudioData('')
      if (isPreview) {
        setSmartTileArray(
          findRequiredArrayForSmartTile(smartTileData.DesktopSmartTileBoxes)
        )
        setShuffledArray(
          twoDimensionShuffle(smartTileData.DesktopSmartTileBoxes)
        )
        setSelectedIndex(0)
      } else {
        setWorkJsonData()
      }
    }
  }, [isTutorPlayed])

  //set data from work json
  function setWorkJsonData() {
    let condition =
      WorkJson !== '' &&
      JSON.parse(WorkJson).filter(
        (e) => e.ContentID === ContentID && e.ModeName === 'Tile'
      ).length > 0
    if (condition) {
      let indexOfType = -1
      indexOfType = JSON.parse(WorkJson).findIndex(
        (obj) => obj.ContentID === ContentID && obj.ModeName === 'Tile'
      )
      const workJson = JSON.parse(WorkJson)[indexOfType]
      //Set score from saved data
      setCurrentScore(workJson.Score)
      setCurrentScoreReset(workJson.ResetScore ? workJson.ResetScore : 0)
      setCumulativeAverageScoreOld(
        workJson.CumulativeAverageScoreOld
          ? workJson.CumulativeAverageScoreOld
          : 0
      )
      //Set attempts from saved data
      setAttempt(workJson.AttemptsOverall ? workJson.AttemptsOverall : 0)
      setAttemptsPractice(workJson.Attempts)
      //set total resets from saved data
      setTotalResetPractice(
        workJson.TotalResetPractice ? workJson.TotalResetPractice : 0
      )
      setTotalResetOld(workJson.TotalResetOld ? workJson.TotalResetOld : 0)
      //Set answered top tile and remaining tiles from saved data
      if (smartTileData.DesktopSmartTileBoxes.length !== 0) {
        let modifiedArray = smartTileData.DesktopSmartTileBoxes.map(
          (c, index) => {
            let childModifiedArray = c.map((itemValue, i) => {
              for (let j = 0; j < workJson.listControls.length; j++) {
                if (itemValue.ControlID === workJson.listControls[j].CtlId) {
                  itemValue.defaultInput = workJson.listControls[j].CtlValue
                  itemValue.elapsedTime = workJson.listControls[j].elapsedTime
                }
              }
              return itemValue
            })
            return childModifiedArray
          }
        )
        setSmartTileArray(modifiedArray)
        let shuffledCopy = shuffle(workJson.remainingShuffledArray)
        setShuffledArray(shuffledCopy)

        // shuffledCopy[selectedIndex].disabled = true
        // setShuffledArray(shuffledCopy)

        let filteredData = shuffledCopy.filter((e) => e.disabled !== true)
        if (filteredData.length > 0) {
          let nextHeaderItemCopy = filteredData[0]
          if (nextHeaderItemCopy) {
            const nextItemIndex = shuffledCopy.findIndex(
              (shuffledElement) =>
                shuffledElement.ControlID === nextHeaderItemCopy.ControlID
            )
            setSelectedIndex(nextItemIndex)
            // if (nextItemIndex < shuffledArray.length - 1) {
            //   //setSelectedIndex((selectedIndex) => selectedIndex + 1)

            // } else {
            //   setSelectedIndex(0)
            // }
          }
        }
        // setSelectedIndex(0)
      }
    } else {
      setSmartTileArray(
        findRequiredArrayForSmartTile(smartTileData.DesktopSmartTileBoxes)
      )
      setShuffledArray(twoDimensionShuffle(smartTileData.DesktopSmartTileBoxes))
      setSelectedIndex(0)
    }
    getActivityLoaded(false)
  }

  //Set header item once shuffled array is set
  useEffect(() => {
    if (selectedIndex >= 0) {
      setIsEmptyTileVisible(true)
      if (
        smartTileData &&
        smartTileData.TextToSpeech &&
        smartTileData.TextToSpeech.length !== 0 &&
        smartTileData.TextToSpeech[0] !== ''
      ) {
        if (isBgAudioPlayed) {
          if (shuffledArray.length > 0) {
            const sourceItem = shuffledArray[selectedIndex]
            sourceItem.defaultInput = sourceItem.TopSrc
            setSourceItem(sourceItem)
          } else {
            setSourceItem(undefined)
          }
        }
      } else {
        if (shuffledArray.length > 0) {
          const sourceItem = shuffledArray[selectedIndex]
          sourceItem.defaultInput = sourceItem.TopSrc
          setSourceItem(sourceItem)
        } else {
          setSourceItem(undefined)
        }
      }
    }
  }, [selectedIndex])

  useEffect(() => {
    if (isEmptyTileVisible) {
      setTimeout(() => {
        setIsEmptyTileVisible(false)
      }, 1000)
    }
  }, [isEmptyTileVisible])

  //set hint message when header item updated
  useEffect(() => {
    if (sourceItem) {
      setHintMessage(sourceItem.SequenceHint)
      if (smartTileData.TopTile === 'audio') {
        if (sourceItem.disabled) {
          stopAudio()
        } else {
          stopAudio()
          setSound(sourceItem.TopSrc)
        }
      }
    }
  }, [sourceItem])

  //play audio if source item is audio
  useEffect(() => {
    if (sound && Completed === 0 && isActive) {
      let audio = new Audio(sound)
      audio.play()
      setPlaying(true)
      audio.addEventListener('ended', () => setPlaying(false))
      audio.removeEventListener('ended', () => setPlaying(false))
      setAudio(audio)
    } else {
      console.log('No audio to play')
    }
  }, [sound])

  //Play audio file
  function playAudio(source) {
    let soundSource = source ? source : sound
    if (soundSource) {
      stopAudio()
      let audio = new Audio(soundSource)
      audio.play()
      setAudio(audio)
      setPlaying(true)
      audio.addEventListener('ended', () => setPlaying(false))
      audio.removeEventListener('ended', () => setPlaying(false))
    } else {
      console.log('No audio to play')
    }
  }
  //Stop audio is playing
  function stopAudio() {
    if (audio) {
      audio.pause()
      audio.currentTime = 0
      setSound(undefined)
      setPlaying(false)
    }
  }

  //Validation functionalities
  //calculate score for every attempt
  useEffect(() => {
    let score = 0
    smartTileArray.forEach((rowItem) => {
      rowItem.forEach((tileItem) => {
        if (tileItem.defaultInput === tileItem.TopSrc) {
          score += parseInt(tileItem.Weight)
        }
      })
    })
    setCurrentScore(score)
    let modifyCurrentScore = scoreForPractice()
    setCurrentScoreApi(currentScoreReset + modifyCurrentScore)
  }, [attempt, smartTileArray])
  useEffect(() => {
    getStudentCurrentScore(currentScore)
  }, [currentScore, currentScoreApi])

  //call when user attend the activity
  function validateCorrectAnswer(element) {
    setHintClick(false)
    setAnsweredTile(element)
    if (!element.defaultInput && !selectedValue) {
      if (shuffledArray[selectedIndex].disabled) {
        // showOrHideToaster(true, TILE_MATCHED, 'warning')
      } else {
        let originalArray = smartTileArray
        // find RowIned
        let rindex = -1
        let cindex = -1
        for (let iIndex = 0; iIndex < originalArray.length; iIndex++) {
          const rowItem = originalArray[iIndex]
          if (rowItem.some((e) => e.ControlID === element.ControlID)) {
            rindex = iIndex
          }
        }
        cindex = originalArray[rindex].findIndex(
          (originalElement) => originalElement.ControlID === element.ControlID
        )
        if (cindex >= 0) {
          if (isPractice) {
            const feedbackData = sourceItem
            //Find answered component feedbackdata
            const currentFeedbackData = feedbackData.FeedbackAudioData
            //Get success feedback data
            const currentLabelSuccessData = currentFeedbackData.successData
            //Get failure feedback or hint randomly
            const currentFailureFeedbackData = currentFeedbackData.failureData
            const currentLabelFailureData = getNonRepeatingFeedback(
              selectedIndex,
              currentFailureFeedbackData
            )
            if (
              originalArray[rindex][cindex].TopSrc ===
              shuffledArray[selectedIndex].TopSrc
            ) {
              getValidationFeedback('success', true)
              if (
                currentLabelSuccessData.successAudioLink &&
                currentLabelSuccessData.successAudioLink !== ''
              ) {
                //Play succesfeedback if available
                setFeedbackType('success')
                setTtsPlayType(FEEDBACK_BOT)
                setBotAudioData(currentLabelSuccessData.successAudioLink)
                setTtsData(currentLabelSuccessData.successFeedback)
                setTutorialStart(true)
                //Place answered tile on the top source
                originalArray[rindex][cindex].defaultInput =
                  shuffledArray[selectedIndex].TopSrc
                originalArray[rindex][cindex].elapsedTime =
                  minutes + ':' + seconds
                setSmartTileArray(originalArray)
                setSelectedValue(undefined)
              } else {
                //Placed and move to next item if feedback not available
                updateAnsweredTile(element)
              }
            } else {
              getValidationFeedback('failure', true)
              if (
                currentLabelFailureData.failureAudioLink &&
                currentLabelFailureData.failureAudioLink !== ''
              ) {
                //Play failurefeedback if available
                setFeedbackType('failure')
                setTtsPlayType(FEEDBACK_BOT)
                setBotAudioData(currentLabelFailureData.failureAudioLink)
                setTtsData(currentLabelFailureData.failureFeedback)
                setTutorialStart(true)
              } else {
                //Placed and move to next item if feedback not available
                updateAnsweredTile(element)
              }
            }
          } else {
            updateAnsweredTile(element)
          }
          setAttempt((attempt) => attempt + 1)
          setAttemptsPractice((attempts) => attempts + 1)
        }
      }
    } else {
      if (selectedValue) {
        const secondaryTemp = selectedValue.defaultInput
        let originalArray = smartTileArray
        let temp = element.defaultInput
        for (let iIndex = 0; iIndex < originalArray.length; iIndex++) {
          const rowItem = originalArray[iIndex]
          for (let jIndex = 0; jIndex < rowItem.length; jIndex++) {
            const tileItem = rowItem[jIndex]
            if (tileItem === selectedValue) {
              originalArray[iIndex][jIndex].defaultInput = temp
            } else if (tileItem === element) {
              originalArray[iIndex][jIndex].defaultInput = secondaryTemp
            }
            originalArray[iIndex][jIndex].elapsedTime = minutes + ':' + seconds
          }
        }
        setSmartTileArray(originalArray)
        setSelectedValue(undefined)
        setAttempt((attempt) => attempt + 1)
        setAttemptsPractice((attempts) => attempts + 1)
        let shuffledCopy = [...shuffledArray]
        shuffledCopy[selectedIndex].disabled = true
        setShuffledArray(shuffledCopy)
        if (selectedIndex < shuffledArray.length - 1) {
          setSelectedIndex((selectedIndex) => selectedIndex + 1)
        } else {
          setSelectedIndex(0)
        }
      } else {
        setSelectedValue(element)
        const index = shuffledArray.findIndex(
          (shuffledElement) => shuffledElement.TopSrc === element.defaultInput
        )
        let shuffledCopy = [...shuffledArray]
        shuffledCopy[index].disabled = false
        setShuffledArray(shuffledCopy)
        setSelectedIndex(index)
      }
    }
  }

  function updateAnsweredTile(element) {
    let originalArray = smartTileArray
    // find RowIned
    let rindex = -1
    let cindex = -1
    for (let iIndex = 0; iIndex < originalArray.length; iIndex++) {
      const rowItem = originalArray[iIndex]
      if (rowItem.some((e) => e.ControlID === element.ControlID)) {
        rindex = iIndex
      }
    }
    cindex = originalArray[rindex].findIndex(
      (originalElement) => originalElement.ControlID === element.ControlID
    )
    if (cindex >= 0) {
      originalArray[rindex][cindex].defaultInput =
        shuffledArray[selectedIndex].TopSrc
      originalArray[rindex][cindex].elapsedTime = minutes + ':' + seconds
      setSmartTileArray(originalArray)
      setSelectedValue(undefined)

      let shuffledCopy = [...shuffledArray]
      shuffledCopy[selectedIndex].disabled = true
      setShuffledArray(shuffledCopy)

      let filteredData = shuffledCopy.filter((e) => e.disabled !== true)
      if (filteredData.length > 0) {
        let nextHeaderItemCopy = filteredData[0]
        if (nextHeaderItemCopy) {
          const nextItemIndex = shuffledCopy.findIndex(
            (shuffledElement) =>
              shuffledElement.ControlID === nextHeaderItemCopy.ControlID
          )
          setSelectedIndex(nextItemIndex)
          // if (nextItemIndex < shuffledArray.length - 1) {
          //   //setSelectedIndex((selectedIndex) => selectedIndex + 1)

          // } else {
          //   setSelectedIndex(0)
          // }
        }
      }

      // if (selectedIndex < shuffledArray.length - 1) {
      //   setSelectedIndex((selectedIndex) => selectedIndex + 1)
      // } else {
      //   setSelectedIndex(0)
      // }
    }
    setAnsweredTile(undefined)
  }

  // useEffect(() => {
  //   if (shuffledArray.length > 0) {
  //     filterAndFindNextItem()
  //   }
  // }, [shuffledArray])

  let [nextCount, setNextCount] = useState(0)

  useEffect(() => {
    filterAndFindNextItem(nextCount)
  }, [nextCount])

  function filterAndFindNextItem(increment) {
    let filteredData = shuffledArray.filter((e) => e.disabled !== true)
    if (filteredData.length > 0) {
      let nextHeaderItemCopy = filteredData[increment]
      if (nextHeaderItemCopy) {
        const nextItemIndex = shuffledArray.findIndex(
          (shuffledElement) =>
            shuffledElement.ControlID === nextHeaderItemCopy.ControlID
        )
        setSelectedIndex(nextItemIndex)
      }
    }
  }

  //call when user skip the header item
  function skip(skipType) {
    let filteredData = shuffledArray.filter((e) => e.disabled !== true)
    if (skipType === 'top') {
      if (nextCount === filteredData.length - 1) {
        // setSelectedIndex(0)
        setNextCount(0)
      } else {
        setNextCount((nextCount) => nextCount + 1)
        // setSelectedIndex((selectedIndex) => selectedIndex + 1)
      }
    } else {
      if (nextCount === 0) {
        // setSelectedIndex(shuffledArray.length - 1)
        setNextCount(filteredData.length - 1)
      } else {
        //setSelectedIndex((selectedIndex) => selectedIndex - 1)
        setNextCount((nextCount) => nextCount - 1)
      }
    }
  }

  //calculate average to send api
  function calculateAverage() {
    let overallAverageScore = 0
    let modifyCurrentScore = 0
    if (totalScore && totalScore !== 0) {
      let calculateScAt = calculateTotalComponents()
      if (calculateScAt < 1) {
        let modifyScore = Math.round(currentScore * calculateScAt)
        modifyCurrentScore = modifyScore
      } else {
        modifyCurrentScore = currentScore
      }
      let currentAverageScore = Math.round(
        (modifyCurrentScore / totalScore) * 100
      )
      if (cumulativeAverageScoreOld === 0) {
        overallAverageScore = Math.round(
          (modifyCurrentScore / totalScore) * 100
        )
      } else {
        overallAverageScore = Math.round(
          (cumulativeAverageScoreOld * totalResetOld + currentAverageScore) /
            (totalResetPractice + 1)
        )
      }
    }
    return overallAverageScore
  }

  //calculate total number of tiles
  function calculateTotalComponents() {
    let calculateScAt = 0
    if (ActivityJson) {
      const exercise = JSON.parse(ActivityJson)
      let noOfComponents = exercise.TotalTiles

      if (attemptsPractice !== 0) {
        calculateScAt = noOfComponents / attemptsPractice
      }
    }
    return calculateScAt
  }

  //calculate score for practice
  function scoreForPractice() {
    let modifyCurrentScore = 0
    let calculateScAt = calculateTotalComponents()
    if (calculateScAt < 1) {
      let modifyScore = Math.round(currentScore * calculateScAt)
      modifyCurrentScore = modifyScore
    } else {
      modifyCurrentScore = currentScore
    }
    return modifyCurrentScore
  }

  //save studentDataCall
  useEffect(() => {
    if (activitySaveClick) {
      getStudentWork()
    }
  }, [activitySaveClick])

  function getStudentWork() {
    stopAudio()
    let shuffledCopy = []
    if (selectedValue) {
      const index = shuffledArray.findIndex(
        (shuffledElement) =>
          shuffledElement.TopSrc === selectedValue.defaultInput
      )
      shuffledCopy = [...shuffledArray]
      shuffledCopy[index].disabled = true
      setShuffledArray(shuffledCopy)
    } else {
      shuffledCopy = [...shuffledArray]
    }
    setSelectedValue(undefined)
    let listArray = []
    for (let i = 0; i < smartTileArray.length; i++) {
      let tileRow = smartTileArray[i]
      for (let j = 0; j < tileRow.length; j++) {
        listArray.push({
          CtlId: tileRow[j].ControlID,
          CtlValue: tileRow[j].defaultInput,
          elapsedTime: tileRow[j].elapsedTime
        })
      }
    }
    let workData = {}
    if (IsReadonly) {
      workData = {
        ContentID: ContentID,
        ModeName: 'Tile',
        TimeTaken: minutes + ':' + seconds
      }
    } else {
      //Attempts-current
      //AttemptsPractice-cumulative
      workData = {
        ContentID: ContentID,
        ModeName: 'Tile',
        Score: currentScore,
        TimeTaken: minutesPractice + ':' + secondsPractice,
        Attempts: attemptsPractice,
        listControls: listArray,
        remainingShuffledArray: shuffledCopy,
        TotalScore: isPractice ? currentScoreApi : currentScore,
        TimeTakenOverall: minutes + ':' + seconds,
        AttemptsOverall: attempt,
        TotalResetPractice: totalResetPractice,
        ResetScore: currentScoreReset,
        CumulativeAverageScoreOld: cumulativeAverageScoreOld,
        TotalResetOld: totalResetOld,
        Platform: 'Web'
      }
    }
    let allWorkData = []

    //Store normal activity data in workjson
    if (WorkJson === '') {
      allWorkData = [workData]
    } else {
      const workJson = JSON.parse(WorkJson)
      if (
        workJson.filter(
          (e) => e.ContentID === ContentID && e.ModeName === 'Tile'
        ).length > 0
      ) {
        const workJsonCopy = [...workJson]
        const index = workJsonCopy.findIndex(
          (element) =>
            element.ContentID === ContentID && element.ModeName === 'Tile'
        )
        workJsonCopy[index] = workData
        allWorkData = workJsonCopy
      } else {
        allWorkData = [...workJson, workData]
      }
    }

    const completed = activitySaveType === SAVE_MODE.SAVE ? 0 : 1
    const resetData = activitySaveType === SAVE_MODE.SAVE ? resetValue : 0
    let studentActivityData = JSON.stringify({
      LessonUnitDistID: currentLessonUnitDistId,
      StudentID: user.LoginID,
      DomainID: user.DomainID,
      ContentID: ContentID,
      Completed: completed,
      TotalPoints: !isPractice ? currentScore : scoreForPractice(),
      Attempts: attemptsPractice,
      Work: JSON.stringify([workData]),
      Ink: '',
      SpentTime: getTimeSpent(minutesPractice, secondsPractice, false),
      Reset: resetData,
      SubmitDate: getSubmitDate(),
      CumulativeAttempts: attempt,
      CumulativeTimeTaken: getTimeSpentOverall(minutes, seconds, false),
      CumulativeAverage: calculateAverage(),
      TotalTries: totalResetPractice + 1
    })
    getStudentWorkedDataFromChild(studentActivityData)
  }

  useEffect(() => {
    knovoHelpClose()
    if (activityResetType === 'resetPractice') {
      funcResetPractice()
    } else if (activityResetType === 'resetTest') {
      funcReset()
    }
  }, [activityResetType])

  function funcReset() {
    stopAudio()
    setAttempt(0)
    setCurrentScore(0)
    setSmartTileArray(
      findRequiredArrayForSmartTile(smartTileData.DesktopSmartTileBoxes)
    )
    setResetValue(1)
    setHintClick(false)
    setTimeout(() => {
      setSelectedValue(undefined)
      setSourceItem(undefined)
      setShuffledArray(
        twoDimensionShuffle(smartTileData.DesktopSmartTileBoxes, true)
      )
      setSelectedIndex(0)
    }, 500)
    setExplanationClick(false)
    getActivityResetStatus()
  }

  function funcResetPractice() {
    stopAudio()
    let calculateScAt = calculateTotalComponents()
    let modifyCurrentScore = 0
    if (calculateScAt < 1) {
      let modifyScore = Math.round(currentScore * calculateScAt)
      modifyCurrentScore = modifyScore
    } else {
      modifyCurrentScore = currentScore
    }
    setCurrentScoreReset(
      (currentScoreReset) => currentScoreReset + modifyCurrentScore
    )
    setSmartTileArray(
      findRequiredArrayForSmartTile(smartTileData.DesktopSmartTileBoxes)
    )
    setAttemptsPractice(0)
    setHintClick(false)
    let tempScoreAverage =
      (currentScoreApi / ((totalResetPractice + 1) * totalScore)) * 100
    setCumulativeAverageScoreOld(tempScoreAverage)
    setTotalResetOld(totalResetPractice + 1)
    setTotalResetPractice((totalResetPractice) => totalResetPractice + 1)
    setCurrentScore(0)
    setTimeout(() => {
      setSelectedValue(undefined)
      setSourceItem(undefined)
      setShuffledArray(
        twoDimensionShuffle(smartTileData.DesktopSmartTileBoxes, true)
      )
      setSelectedIndex(0)
    }, 500)
    setExplanationClick(false)
    setcurrentDisplayMode('normal')
    getActivityResetStatus()
  }

  // Setting Answer Explanation
  function handleExplanationChange(explanationStatus, explanationString) {}

  return (
    <div
      className='tile-main'
      style={{
        backgroundImage: `url(${smartTileData.BackgroundImage})`
      }}
    >
      <div className='tile-header-cont'>
        {isBgAudioPlayed && shuffledArray.length > 0 && (
          <HeaderCarousel
            completed={Completed}
            isActive={isActive}
            smartTileData={smartTileData}
            selectedIndex={selectedIndex}
            shuffledArray={shuffledArray}
            onSkipClick={(skipType) => skip(skipType)}
            audioPlaying={playing}
            onAudioClicked={() => {
              if (playing) {
                stopAudio()
              } else {
                if (sourceItem) {
                  playAudio(sourceItem.defaultInput)
                }
              }
            }}
            isAudioPlaying={!isAudioPlaying}
          />
        )}
      </div>
      <div className='tile-canvas-cont'>
        <span
          style={{
            backgroundColor: smartTileData.Opacity,
            height: '100%',
            width: '100%',
            position: 'absolute'
          }}
        />
        {smartTileArray.length > 0 &&
          smartTileArray.map((rowItem, index) => {
            if (maxColumnCount < rowItem.length) {
              setMaxColumnCount(rowItem.length)
            }
            return (
              <div
                key={index.toString()}
                className='smart-tile-row'
                style={{
                  fontFamily: smartTileData.FontName,
                  color: smartTileData.FontColor,
                  fontStyle:
                    smartTileData.Italic && smartTileData.Italic
                      ? 'italic'
                      : 'normal',
                  fontWeight:
                    smartTileData.Bold && smartTileData.Bold
                      ? 'bold'
                      : 'normal',
                  fontSize:
                    smartTileData.FontSize && smartTileData.FontSize === 'SMALL'
                      ? SMALL_DESKTOP
                      : smartTileData.FontSize === 'LARGE'
                      ? LARGE_DESKTOP
                      : MEDIUM_DESKTOP
                }}
              >
                {rowItem.map((tileItem, index) => {
                  return (
                    <SmartTile
                      key={index.toString()}
                      controlID={tileItem.ControlID}
                      smartTileData={smartTileData}
                      topTileType={smartTileData.TopTile}
                      bottomTileType={smartTileData.BottomTile}
                      topTileSource={tileItem.TopSrc}
                      bottomTileSource={tileItem.BottomSrc}
                      topTileFlex={topTileFlex}
                      bottomTileFlex={bottomTileFlex}
                      columnCount={maxColumnCount}
                      rowCount={smartTileArray.length}
                      defaultValue={tileItem.defaultInput}
                      onValueSelect={() => validateCorrectAnswer(tileItem)}
                      selected={tileItem === selectedValue}
                      onStopPress={() => stopAudio()}
                      playing={playing}
                      isPractice={isPractice}
                      completed={Completed}
                      isActive={isActive}
                      correctAnswerExplanation={
                        tileItem.CorrectAnswerExplanation
                      }
                      incorrectAnswerExplanation={
                        tileItem.IncorrectAnswerExplanation
                      }
                      explanationClick={explanationClick && explanationClick}
                      onExplanationVisible={handleExplanationChange}
                      screenMode={'desktop'}
                      isVerifyMode={isVerifyMode}
                      FillColor={smartTileData.FillColor}
                      FontColor={smartTileData.FontColor}
                      selectedItem={
                        shuffledArray.length > 0 && shuffledArray[selectedIndex]
                      }
                      reselectedTile={selectedValue}
                      isEmptyTileVisible={isEmptyTileVisible}
                      isAudioPlaying={!isAudioPlaying}
                    />
                  )
                })}
              </div>
            )
          })}
        {/* {isKnovoHelpOpen && (
          <KnovoHelp
            Completed={Completed}
            isActive={isActive}
            isPractice={isPractice}
            onBotAnimeClose={() => {
              setcurrentDisplayMode("normal");
              knovoHelpClose();
            }}
            onKnovoHelpSelected={(helpSelected, isShowAnswer) => {
              if (helpSelected === "tips") {
                setcurrentDisplayMode("normal");
                knovoHelpClose();
              } else if (helpSelected === "instruction") {
                setcurrentDisplayMode("normal");
                knovoHelpClose();
              } else if (helpSelected === "walkthrough") {
                setcurrentDisplayMode("normal");
                knovoHelpClose();
                //  knovoActivityTourClick();
              } else {
                if (isPractice || Completed === 1 || !isActive) {
                  if (isShowAnswer) {
                    setcurrentDisplayMode("verify");
                  } else {
                    setcurrentDisplayMode("normal");
                  }
                }
              }
            }}
          />
        )} */}

        {isBgAudioPlayed && botAudioData !== '' && (
          <BotAssistSettings
            audioUrl={botAudioData}
            text={ttsData}
            tutorialStart={tutorialStart}
            botType={ttsPlayType}
            getTutorTalking={(audioStatus) => {
              setIsAudioPlaying(audioStatus)
              getTutorTalking(audioStatus)
            }}
            isAudioForcedStopped={isAudioForcedStopped}
            isMinimize={isMinimize}
            onBotComplete={() => {
              setTutorialStart(false)
              setIsTutorPlayed(true)
              if (ttsPlayType === FEEDBACK_BOT) {
                setTtsPlayType('')
                setBotAudioData('')
                if (feedbackType === 'success') {
                  if (answeredTile) {
                    updateAnsweredTile(answeredTile)
                  }
                } else {
                  setAnsweredTile(undefined)
                }
              }
            }}
            onBotStopped={() => {
              setTutorialStart(false)
            }}
            onFrwdSkipClick={() => {}}
          />
        )}
      </div>
    </div>
  )
}

export { SmartTileMainScreen }
